// @flow
export const styles: Function = (theme: Object): Object => ({
    root: {
        flexGrow: 1,
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        minWidth: 200,
        backgroundColor: '#f8f8f8',
        justifyContent: 'center',
        minHeight: theme.constants.MIN_HEIGHT_LIMITED_LAYOUT,
    },
    container: {
        boxSizing: 'border-box',
        padding: '24px 30px',
        maxWidth: theme.overrides.MuiToolbar.root.maxWidth,
        width: '100%',
    },
    headline: {
        fontSize: 24,
        fontWeight: 500,
    },
    subheadline: {
        fontSize: 20,
        fontWeight: 500,
        letterSpacing: 0.3,
    },
    title: {
        fontSize: 16,
        fontWeight: 500,
        lineHeight: 1.5,
        letterSpacing: 0.2,
        marginBottom: 10,
    },
    section: {
        fontSize: 14,
        lineHeight: 1.43,
        letterSpacing: 0.3,
        color: '#554d56',
    },
    divider: {
        width: 20,
        height: 20,
    },
    paper: {
        padding: 24,
        boxShadow: '0 10px 10px 0 rgba(155, 155, 155, 0.07)',
        // minHeight: 444
    },
    dateCaption: {},
    link: {
        color: '#6cb720',
    },
});

export default styles;
